// Ported from dev-scrips-pm-react src/shared/api/billing-client.ts (PROD-1119 Patients data layer).
/**
 * Billing API base paths.
 *
 * Two distinct .NET microservices, both reachable through the same
 * `apiClient`. Mirror Flutter's `billingAPI(BillingService.Billing)` and
 * `billingAPI(BillingService.CashierShift)` URL builders.
 *
 * Usage:
 *   import { BILLING_BASE, CASHIER_BASE } from '@/shared/api/billing-client';
 *   const lists = await get<ServiceListModel[]>(`${BILLING_BASE}/ServiceLists`);
 */

export const BILLING_BASE = '/api/Billing';
export const CASHIER_BASE = '/api/CashierShift';
